import React from 'react';
import styled from 'styled-components';
import Ratings from 'src/elements/rating/rating';

const DynamicRatingsContainer = styled.div`
  margin: 1.5rem auto;
`

export default function getDynamicRatings(): React.ReactNode {
  return (
    <DynamicRatingsContainer>
      <Ratings />
    </DynamicRatingsContainer>
  )
}
